var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100MicGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#828282",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66666 5.82895H4.23333C4.23333 6.08211 4.28666 6.31816 4.37666 6.53027L3.96666 6.95106C3.77999 6.61579 3.66666 6.23606 3.66666 5.82895ZM5.00666 5.88711C5.00666 5.86658 5 5.84948 5 5.82895V3.77632C5 3.20842 5.44666 2.75 6 2.75C6.55333 2.75 7 3.20842 7 3.77632V3.8379L5.00666 5.88711ZM8.57667 3.09211L9 3.52658L6.99666 5.58263V5.82895C6.99666 6.39685 6.55333 6.85527 6 6.85527C5.92666 6.85527 5.85333 6.845 5.78333 6.8279L5.23 7.39579C5.46666 7.50869 5.73 7.57369 6 7.57369C6.92 7.57369 7.76667 6.85527 7.76667 5.82895H8.33333C8.33333 6.99553 7.42666 7.96027 6.33333 8.1279V9.25001H5.66666V8.1279C5.36333 8.08343 5.07666 7.97395 4.82 7.82001L3.42333 9.25001L2.99999 8.81553L8.57667 3.09211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100MicGray);
export default __webpack_public_path__ + "static/media/100-mic-gray.0a16bed3139bc03a4a78f709cbd77435.svg";
export { ForwardRef as ReactComponent };